import { Action } from '../../../shared/xs/actions';

export class OpenEsgFinishPopupAction implements Action {
  static readonly type = '[Assessment] open finish popup';
}
